import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

// Plain mark without a circle, for places that already draw their own badge
const CheckIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M5 12.5L9.5 17L19 7.5" />
	</SvgIcon>
)

export default CheckIconAtom
